<template>
  <v-dialog v-model="dialog" width="1870">
    <v-card min-height="80vh">
      <v-card-text class="pt-4">
        <div class="d-flex align-center justify-space-between">
          <div class="d-flex align-center pl-2">
            <h2 class="order_dialog_number_application">
              {{ $t("contractNumber") }}:
              <span class="black--text">{{ categoryInfo.code }}</span>
            </h2>
          </div>
          <div>
            <v-btn
              text
              fab
              small
              color="#01617F"
              class="ml-5"
              @click="dialog = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </div>
        <div class="d-flex pl-2 mt-1 mb-5">
          <div v-if="categoryInfo.conclusionDate" class="mr-4">
            <span class="bold_16_333F54">{{ $t("contractDate") }}: </span>
            <span>{{ categoryInfo.conclusionDate | dateParse }}</span>
          </div>
          <span v-if="categoryInfo.conclusionDate">//</span>
          <div v-if="categoryInfo.conclusionDate" class="ml-4">
            <span class="bold_16_333F54">{{ $t("guessReceiveDate") }}: </span>
            <span>{{ categoryInfo.guessReceiveDate | dateParse }}</span>
          </div>
        </div>
        <div>
          <div class="d-flex pl-2 mb-4">
            <span
              class="d-inline-block primary--text font-weight-bold"
              v-if="categoryInfo.state"
              >{{ $t("state") }}: {{ $t(categoryInfo.state) }}
            </span>
          </div>
        </div>
        <v-divider class="mb-4" />

        <viewer-window>
          <template #left>
            <v-card :loading="loading" class="elevation-0">
              <v-container class="pa-0 user_modal_form ozl_table_modal_from">
                <div
                  class="d-flex flex-column mb-4"
                  style="width: 100%; height: 55vh; overflow: auto"
                >
                  <order-dialog-header
                    v-for="(item, index) in categoryInfo.items"
                    :key="`index${index}`"
                  >
                    <template #header>
                      <div class="d-flex" style="width: 100%">
                        <span class="d-inline-block mr-2" style="width: 50px">{{
                          index + 1
                        }}</span>
                        <span
                          class="d-inline-block mr-2"
                          style="min-width: 30%; max-width: 30%"
                          >{{ item.productName }}</span
                        >
                        <span
                          class="d-inline-block mr-2 flex"
                          style="text-transform: lowercase; max-width: 30%"
                          >{{ item.count }}
                          {{ item[`unit_type_name_${$i18n.locale}`] }}</span
                        >
                        <!--                        <span class="d-inline-block mr-2 flex" style="text-transform: lowercase; max-width: 35%">{{item.productTypeName}}</span>-->
                        <span
                          style="max-width: 30%"
                          class="d-inline-block mr-2 flex"
                          :style="{
                            textTransform: 'lowercase',
                            color: item.statusColour,
                          }"
                          >{{ $t(item.statusCode) }}
                        </span>
                      </div>
                    </template>
                    <template #details>
                      <h4 class="mb-2">
                        {{ $t("contractDate") }}:
                        {{ item.itemConclusionDate | dateParse }}
                      </h4>
                      <h4>
                        {{ $t("guessReceiveDate") }}:
                        {{ item.itemGuessReceiveDate | dateParse }}
                      </h4>
                    </template>
                  </order-dialog-header>
                </div>
              </v-container>
              <div>
                <!--                <v-data-table-->
                <!--                    disable-pagination-->
                <!--                    :headers="orderTableAddHead"-->
                <!--                    :items="[...formData.orderItems, ...selectedContract]"-->
                <!--                    class="order_add_table"-->
                <!--                    hide-default-footer-->
                <!--                >-->
                <!--                  <template #item.unitTypeName={item}>{{ item[`unit_type_name_${$i18n.locale}`] }}</template>-->
                <!--                </v-data-table>-->
              </div>
              <div>
                <files-wrap
                  ref="fileWrapRef"
                  @showFile="(data) => $refs.pdfViewer.showFile(data)"
                  class="mt-5"
                  :title="$t('documents')"
                  :files.sync="addFiles"
                />
              </div>
            </v-card>
          </template>
          <template #right>
            <v-card
              height="100%"
              class="elevation-0"
              :disabled="disabledFileView"
            >
              <pdf-viewer
                :contractId="categoryInfo.id"
                ref="pdfViewer"
                @upload-file="onUploadFile"
                clearable
              />
            </v-card>
          </template>
        </viewer-window>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import ViewerWindow from "@/components/ui/viewer-window/ViewerWindow";
import moment from "moment";
import { deliveryTypes } from "@/utils/constants";
import PdfViewer from "@/components/pdf/PdfViewer";
import FilesWrap from "@/components/ui/files-wrap/FilesWrap";
import OrderDialogHeader from "@/components/order-dialog-header/OrderDialogHeader";

export default {
  name: "OzlOrderViewDialog",
  data() {
    return {
      items: [],
      viewItems: [],
      disabledFileView: false,
      loading: false,
      dialog: false,
      supplierDialog: false,
      selectedContract: [],
      initiators: [],
      contracts: [],
      addFiles: [],
      documentFile: null,
      categoryInfo: {},
    };
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.$refs.pdfViewer.clear();
        this.addFiles = [];
        this.selectedContract = [];
      }
    },
  },
  methods: {
    onUploadFile(file) {
      if (!this.addFiles.length) {
        this.addFiles.push(file);
      }
      this.isFileUpdated = true;
      this.isDisabledForm = false;
    },
    open({ items }) {
      items[0].contractLink = null;
      // this.selectHandlerContract(items[0].contractId);
      this.getContractInfo(items[0].contractId);
      this.formData = {
        ...this.formData,
        orderItems: items,
      };
      this.dialog = true;

      this.$nextTick(() => {
        if (
          items[0].contractFileName &&
          items[0].contractLink &&
          this.$refs.fileWrapRef
        ) {
          const { fileWrapRef } = this.$refs;
          const file = {
            name: items[0].contractFileName,
            link: items[0].contractLink,
          };
          fileWrapRef.openFile(file);
          this.addFiles = [file];
          this.items = items;
        }
      });
    },
    getContracts({ text, page } = { text: null, page: 0 }) {
      return this.$store.dispatch("getContracts", {
        isMakeContract: true,
        limit: 15,
        code: text,
        page,
      });
    },
    close() {
      this.dialog = false;
    },
    async getContractInfo(contractId) {
      try {
        const {
          data: { data },
        } = await this.$http.get(`contract/office/ozl/${contractId}`);
        this.categoryInfo = data;
      } catch (err) {
        this.setResponseError({ error: err });
      }
    },
    async selectHandlerContract(val) {
      if (val) {
        this.loading = true;
        try {
          const {
            data: { data },
          } = await this.$http.get("orders/items-ozl", {
            params: { contractId: val },
          });
          const contract = this.contracts[this.selectedContractIndex];
          if (contract) {
            if (contract.productResourceLink) {
              const { fileWrapRef } = this.$refs;
              const file = {
                name: contract.productResourceName,
                link: contract.productResourceLink,
              };
              fileWrapRef.openFile(file).then();
              this.addFiles = [file];
            }
            this.formData.guessReceiveDate = moment(
              contract.guessReceiveDate
            ).format("YYYY-MM-DD");
            this.formData.conclusionDate =
              contract.conclusionDate &&
              moment(contract.conclusionDate).format("YYYY-MM-DD");
            this.formData.supplierId = contract.supplierId;
            this.formData.supplyType = contract.supplyType;
          }
          this.selectedContract = data.map((item) => {
            item.className = "old-order";
            return item;
          });
        } catch (e) {
          this.setResponseError({ error: e });
        } finally {
          this.loading = false;
        }
      } else {
        this.selectedContract = [];
      }
    },
  },
  components: {
    OrderDialogHeader,
    FilesWrap,
    ViewerWindow,
    PdfViewer,
  },
  computed: {
    formTitle() {
      if (this.isUpdate) {
        return this.$t("requestNumberN");
      } else {
        return this.$t("createOrder");
      }
    },
    deliveryTypes: () => deliveryTypes,
    selectedContractIndex() {
      if (!this.formData.id) return -1;
      return this.contracts.findIndex(
        (contract) => contract.id === this.formData.id
      );
    },
    orderTableAddHead() {
      return [
        {
          text: this.$t("product"),
          value: "productName",
        },
        { text: this.$t("categoryTMC"), value: "productTypeName" },
        { text: this.$t("productGroup"), value: "productGroupName" },
        { text: this.$t("measureShort"), value: "unitTypeName" },
        { text: this.$t("countShort"), value: "count" },
      ];
    },
  },
};
</script>

<style scoped>
/*.order_add_table {*/
/*  min-height: 320px;*/
/*}*/
</style>
